import { isEmpty } from 'lodash';
import { Router } from '@angular/router';
import { AppUtilsService } from '../services/app-utils.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  orders;
  totalAmount = 0;
  gstAmount = 0;
  subtotal = 0;
  profileDetails = '';
  userName;

  isLogin = false;

  cartordersArray;
  carttotalAmount;
  cartsubtotal;
  cartgstAmount;
  cartItemsRestaurant;

  constructor(public appUtil: AppUtilsService, private router: Router) { }

  ngOnInit() {
    if (!this.appUtil.isNullOrEmpty(JSON.parse(localStorage.getItem('ordersArray')))
      && (Number(localStorage.getItem('totalAmount'))) &&
      ((Number(localStorage.getItem('gstAmount'))) > -1) &&
      (Number(localStorage.getItem('subtotal')))) {

    }

    this.appUtil.status.subscribe((val: any) => {
      if (val) {
        if (localStorage.getItem('userDetails') && this.keyExist()) {
          this.profileDetails =
            JSON.parse(localStorage.getItem('userDetails')).Name ?
              JSON.parse(localStorage.getItem('userDetails')).Name : JSON.parse(localStorage.getItem('userDetails')).Phone;
          //  console.log('this.profileDetails' + (this.profileDetails));
        } else {
          this.profileDetails = localStorage.getItem('ccId');
        }
      }
      this.isLogin = val;
    }, (error: any) => {
      // console.log(error);
    });
    this.appUtil.subscribeOrders.subscribe((data: any) => {
      // if (data) {
      this.cartordersArray = JSON.parse(localStorage.getItem('cartordersArray')) ? JSON.parse(localStorage.getItem('cartordersArray')) : [];
      this.carttotalAmount = Number(localStorage.getItem('carttotalAmount'));
      this.cartsubtotal = Number(localStorage.getItem('cartsubtotal'));
      this.cartgstAmount = Number(localStorage.getItem('cartgstAmount'));
      this.cartItemsRestaurant = JSON.parse(localStorage.getItem('cartItemsRestaurant'));
      // }
    });
  }


  keyExist() {
    return this.appUtil.keyExists(JSON.parse(localStorage.getItem('userDetails')), 'Name');
  }

  empty(data) {
    return !isEmpty(data);
  }
  checkOut() {
    // this.appUtil.fronCart = true;
    localStorage.setItem('fromCart', JSON.stringify(true));

    this.router.navigate(['/checkout']);
  }

  onClick() {
    console.log("routePath:::" + localStorage.getItem('routePath'));
    const paramsId = localStorage.getItem('paramsId');
    const routePath = localStorage.getItem('routePath');
    const paramsObj = localStorage.getItem('paramsObj');

    let homeUrl = localStorage.getItem("homeUrl");


    if (homeUrl) {
      this.router.navigate(['/menus'], { queryParams: { id: paramsId } });
      this.router.navigateByUrl(homeUrl);

    }
    else if (paramsId && routePath === '/menus') {
      this.router.navigate(['/menus'], { queryParams: { id: paramsId } });
    } else if (routePath) {
      let queryParamsObj = paramsObj ? JSON.parse(paramsObj) : {};
      console.log('queryParamsObj:::', queryParamsObj);
      this.router.navigate([routePath], { queryParams: queryParamsObj });
    }

  }
  logout() {
    this.appUtil.selectedTenant = undefined;
    localStorage.removeItem('selectedRestaurant');
    localStorage.removeItem('items');
    localStorage.removeItem('ordersArray');
    localStorage.removeItem('totalAmount');
    localStorage.removeItem('gstAmount');
    localStorage.removeItem('subtotal');
    localStorage.removeItem('ccId');
    localStorage.removeItem('address');
    this.appUtil.logouted();
    // localStorage.clear();
    this.router.navigate(['/login']);
  }
}
